<template>
  <div class="Customerbanonsale">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
      @handleOptionClick="handleOptionClick"
      @selectlinkageclear="selectlinkageclear"
    >
      <template v-slot:right>
        <!-- <el-button type="warning" @click="allclick">批量修改</el-button> -->
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="supplier.title" align="center" label="供应商">
        </el-table-column>
        <el-table-column prop="member.fullname" align="center" label="客户名称">
        </el-table-column>
        <el-table-column prop="member.mobile" align="center" label="手机号">
        </el-table-column>
        <el-table-column
          prop="member.logistics.name"
          align="center"
          label="城市仓"
        >
        </el-table-column>
        <el-table-column
          prop="restriction_type_text"
          align="center"
          label="禁售类型"
        >
          <template slot-scope="scope">
            {{ restriction_type_name(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
         :show-overflow-tooltip="true"
          prop="reason"
          align="center"
          label="申请原因"
        >
        </el-table-column>
        <el-table-column
          prop="restriction_type_text"
          align="center"
          label="禁售内容"
        >
        </el-table-column>
        <el-table-column
          prop="order_amt"
          align="center"
          label="客户售后数据"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ order_amt_name(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          align="center"
          label="申请时间
"
        >
        </el-table-column>
        <el-table-column
          prop="audit_time"
          align="center"
          label="审核时间
"
        >
        </el-table-column>
        <el-table-column
          prop="audit_user.username"
          align="center"
          label="审核人
"
        >
        </el-table-column>
        <el-table-column
          prop="audit_time"
          align="center"
          label="状态
"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ audit_status_name(scope.row) }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.audit_status == 0"
              @click="handleEdit(scope.row)"
              >通过</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.audit_status == 0"
              @click="handleDel(scope.row)"
              >拒绝</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.audit_status == 1"
              @click="Cancel(scope.row)"
              >取消</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="ruleForm.audit_status == 1 ? '通过拉黑申请' : '拒绝拉黑申请'"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="500px"
      class="dialog"
      center
    >
      <div class="contents">
        <div style="margin-bottom: 20px">
          {{ ruleForm.audit_status == 1 ? "" : "拒绝" }}通过{{
            itemobj.supplier.title
          }}供应商的拉黑申请；
        </div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            :label="
              ruleForm.audit_status == 1
                ? '通过原因：(非必填)'
                : '拒绝原因：(非必填)'
            "
            prop="reason"
          >
            <div style="width: 302px">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="ruleForm.audit_reason"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ruleFormqr">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";

export default {
  name: "supplier",
  components: {
    Filtersearch,
  },
  data() {
    return {
      currentPage: 0,
      total: 0,
      loading: false,
      disabledExport: false, // 导出按钮
      tableData: [],
      centerDialogVisible: false,
      Filterdata: "",
      itemobj: "",
      ruleForm: {
        audit_reason: "",
        id: "",
        audit_status: "",
      },
      from: {
        page: 1, //	T文本	是
        pageSize: 50, //	T文本	是
        audit_status: "", //	T文本	是
        member_id: "", //	T文本	是	8
        member_name: "", //	T文本	是	8
        member_mobile: "", //	T文本	是	16619954546
        tdc_id: "", //	T文本	是	623
        supplier_id: "", //	T文本	是	73
        restriction_type: "", //	T文本	是	3
        sku_code: "", //	T文本	是	SR3897934
        logistic_business_id: "", //	T文本	是	2
        first_cid: "", //	T文本	是	2
        cid: "", //	T文本	是	200
      },
      from1: "",
      Selectionlist: [],
      Filtersearchlist: [
        {
          type: "input",
          name: "客户名称",
          clearable: true,
          model: "member_name",
          placeholder: "请输入客户名称",
        },
        {
          type: "input",
          name: "客户电话",
          clearable: true,
          model: "member_mobile",
          placeholder: "请输入客户电话",
        },
        {
          type: "select",
          name: "城市仓",
          clearable: true,
          filterable: true,
          model: "tdc_id",
          placeholder: "请选择城市仓",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "logistics_list",
        },
        {
          type: "select",
          name: "供应商",
          clearable: true,
          filterable: true,
          model: "supplier_id",
          placeholder: "请选择供应商",
          label: "title",
          value: "id",
          selectoption: [],
          selectoptionname: "supplier_list",
        },
        {
          type: "select",
          name: "状态",
          clearable: true,
          model: "audit_status",
          placeholder: "请选状态",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "全部",
              value: "",
            },
            {
              label: "待审核",
              value: 0,
            },
            {
              label: "已通过",
              value: 1,
            },
            {
              label: "已拒绝",
              value: 2,
            },
            {
              label: "供应商取消审核",
              value: 3,
            },
            {
              label: "平台取消",
              value: 4,
            },
          ],
        },
        {
          type: "select",
          name: "类型",
          clearable: true,
          model: "restriction_type",
          placeholder: "请选类型",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "全部",
              value: 1,
            },
            {
              label: "货号",
              value: 2,
            },
            {
              label: "品类",
              value: 3,
            },
          ],
        },
        {
          type: "input",
          name: "货号",
          clearable: true,
          model: "sku_code",
          placeholder: "请输入货号",
        },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "business_list",
        },
        {
          type: "selectlinkage",
          name: "一级分类",
          clearable: true,
          filterable: true,
          model: "first_cid",
          placeholder: "请选一级分类",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "first_category_list",
        },
        {
          type: "select",
          name: "二级分类",
          clearable: true,
          filterable: true,
          model: "cid",
          placeholder: "请选二级分类",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "second_category_list",
        },
      ],
    };
  },
  created() {
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
    this.getsearch();
  },
  watch: {},
  methods: {
    Cancel(e) {
      this.ruleForm.id = e.id;
      this.ruleForm.audit_status = 4;
      this.ruleForm.audit_reason = '';

      this.$confirm("确定要取消吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.ban.memberaudit(this.ruleForm).then((res) => {
            this.$message({
              type: "success",
              message: "已取消",
            });
            this.hqlist();
          });
        })
        .catch(() => {});
    },
    handleDel(e) {
      this.itemobj = e;
      this.ruleForm.id = e.id;
      this.ruleForm.audit_status = 2;
      this.ruleForm.audit_reason = '';

      this.centerDialogVisible = true;
    },
    handleEdit(e) {
      this.itemobj = e;
      this.ruleForm.id = e.id;
      this.ruleForm.audit_status = 1;
      this.ruleForm.audit_reason = '';

      this.centerDialogVisible = true;
    },
    selectlinkageclear() {
      console.log("清除功能");
      this.$refs.Filtersearchref.from.cid = "";
      this.Filtersearchlist.forEach((el) => {
        if (
          el.type == "select" &&
          el.selectoptionname == "second_category_list"
        ) {
          // let obj = { [el.value]: "", [el.label]: "全部" };
          el.selectoption = this.Filterdata["second_category_list"];
        }
      });
    },
    handleOptionClick(e) {
      console.log(e, "11111111");
      this.$refs.Filtersearchref.from.cid = "";
      this.Filtersearchlist.forEach((el) => {
        if (
          el.type == "select" &&
          el.selectoptionname == "second_category_list"
        ) {
          // let obj = { [el.value]: "", [el.label]: "全部" };
          el.selectoption = e.child;
        }
      });
    },
    audit_status_name(e) {
      if (e.audit_status == 0) {
        return "待审核";
      } else if (e.audit_status == 1) {
        return "通过";
      } else if (e.audit_status == 2) {
        return "平台拒绝拉黑客户，" + "拒绝原因：" + e.audit_reason;
      } else if (e.audit_status == 3) {
        return "供应商取消拉黑客户";
      } else if (e.audit_status == 4) {
        return "平台取消拉黑客户";
      }
    },
    order_amt_name(e) {
      return `总下单金额 ${e.all_order_amt}元 ； 售后退款总金额${e.all_refund_amt}元；该供应商下单总金额：${e.order_amt}元，该供应商退款总金额；${e.refund_amt}`;
    },
    restriction_type_name(e) {
      if (e.restriction_type == 1) {
        return "全部";
      } else if (e.restriction_type == 2) {
        return `品类`;
      } else if (e.restriction_type == 3) {
        return `货号`;
      }
    },
    ruleFormqr() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.$api.ban.memberaudit(this.ruleForm).then((res) => {
            this.hqlist();
            this.centerDialogVisible = false;
          });
        }
      });
    },
    /**
     * 导出逻辑
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.from,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;

        this.$api.biexport.blacklistmemberexport(query).then((res) => {
          this.goExportCenter();
        });
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax getAfterSaleNewUnExport err", err);
        console.log("ajax postPurchaseSettleExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    getsearch() {
      this.$api.ban.searchdata().then((res) => {
        console.log(res, "qqqqewq");
        this.Filterdata = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            (el.type == "select" || el.type == "selectlinkage") &&
            el.selectoptionname
          ) {
            // let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = res.data[el.selectoptionname];
          }
        });
      });
    },
    Refresh() {
      this.Filtersearchlist.forEach((el) => {
        if (
          (el.type == "select" || el.type == "selectlinkage") &&
          el.selectoptionname
        ) {
          // let obj = { [el.value]: "", [el.label]: "全部" };
          el.selectoption = this.Filterdata[el.selectoptionname];
        }
      });
      Object.assign(this.$data.from, this.$options.data().from);
      this.from1 = JSON.parse(JSON.stringify(this.from));
      this.hqlist();
    },

    search(e) {
      this.from.page = 1;
      this.currentPage = 1;
      this.from = e;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.ban.blacklistmemberlist(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.Customerbanonsale {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .contents {
    padding: 0 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
